import { render, staticRenderFns } from "./ContentCss.vue?vue&type=template&id=70216bd4&"
import script from "./ContentCss.vue?vue&type=script&lang=ts&"
export * from "./ContentCss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports